<svelte:head>
  <title>Home | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

{#if $appState.user}
  <div class="tile is-ancestor">
    <div class="tile is-vertical is-8">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <Messages/>
        </div>
      </div>
      <div class="tile is-parent">
        <div class="tile is-child box">
          <Offers/>
        </div>
      </div>
    </div>

    <div class="tile is-vertical">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <Area/>
        </div>
      </div>

      <div class="tile is-parent">
        <div
          class="tile is-child box">
          <Needs/>
        </div>
      </div>
    </div>
  
  </div>
{/if}

<script lang="ts">
  import { appState } from '../../lib/appState';
  
  import Messages from './_components/home/Messages.svelte';
  import Offers from './_components/home/Offers.svelte';
  import Needs from './_components/home/Needs.svelte';
  import Area from './_components/home/Area.svelte';
  import FeaturedCharity from './_components/home/FeaturedCharity.svelte';
</script>